<template>
    <div class="modal fade" ref="updateAccountDetails" tabindex="-1" role="dialog"
         aria-hidden="true">
        <div class="modal-dialog" role="document">
            <form>
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">{{ __('sale.account_details') + ' ' + provider.name }}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <i aria-hidden="true" class="ki ki-close"></i>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="text-muted pb-5">
                            {{ __('sale.add_provider.info') }}
                        </div>

                        <div v-if="provider.id === PaymentProvider.PAYPALID">
                            <form-group class="row" label-class="col-4 col-form-label" reference-id="clientId"
                                        :label="__('sale.client_id')">
                                <div class="input-group col-8">
                                    <input v-model="form.clientId" name="clientId" id="clientId"
                                           :class="checkError(form.errors.clientId)"
                                           class="form-control" required type="text"/>
                                </div>
                            </form-group>
                            <form-group class="row" label-class="col-4 col-form-label" reference-id="clientSecret"
                                        :label="__('sale.client_secret')">
                                <div class="input-group col-8">
                                    <input v-model="form.clientSecret" name="clientSecret" id="clientSecret"
                                           class="form-control" required
                                           :class="checkError(form.errors.clientSecret)"
                                           type="text"/>
                                </div>
                            </form-group>
                        </div>

                        <div v-if="provider.id === PaymentProvider.GIROPAYID">
                            <form-group class="row" label-class="col-4 col-form-label" reference-id="projectId"
                                        :label="__('sale.project_id')">
                                <div class="input-group col-8">
                                    <input v-model="form.projectId" name="projectId" id="projectId"
                                           class="form-control" required
                                           :class="checkError(form.errors.projectId)"
                                           type="text"/>
                                </div>
                            </form-group>
                            <form-group class="row" label-class="col-4 col-form-label" reference-id="merchantId"
                                        :label="__('sale.merchant_id')">
                                <div class="input-group col-8">
                                    <input v-model="form.merchantId" name="merchantId" id="merchantId"
                                           class="form-control" required
                                           :class="checkError(form.errors.merchantId)"
                                           type="text"/>
                                </div>
                            </form-group>
                            <form-group class="row" label-class="col-4 col-form-label"
                                        reference-id="projectPassword"
                                        :label="__('sale.project_pw')">
                                <div class="input-group col-8">
                                    <input v-model="form.projectPassword" name="projectPassword"
                                           id="projectPassword"
                                           class="form-control" required
                                           :class="checkError(form.errors.projectPassword)"
                                           type="text"/>
                                </div>
                            </form-group>
                        </div>

                        <div v-if="provider.id === PaymentProvider.GLOBALPAYMENTSID">
                            <form-group class="row" label-class="col-4 col-form-label" reference-id="merchantId"
                                        :label="__('sale.merchant_id')">
                                <div class="input-group col-8">
                                    <input v-model="form.merchantId" name="merchantId" id="merchantId"
                                           class="form-control" required
                                           :class="checkError(form.errors.merchantId)"
                                           type="text"/>
                                </div>
                            </form-group>
                            <form-group class="row" label-class="col-4 col-form-label" reference-id="privateKey"
                                        :label="__('sale.private_key')" :error="form.errors.privateKey">
                                <div class="custom-file col-8">
                                    <input
                                        @change="setPrivateKeyFile($event)"
                                        id="privateKey"
                                        name="privateKey"
                                        class="custom-file-input"
                                        required
                                        :class="checkError(form.errors.privateKey)"
                                        type="file"
                                    />
                                    <label class="custom-file-label mx-4" ref="fileLabel" for="#privateKey"></label>
                                </div>
                                <span class="pt-2 pl-4 text-warning">
                                        {{ __('sale.globalpayment_key_format') }}
                                    </span>
                                <span class="pt-2 pl-4 text-warning">

                                        {{ __('sale.globalpayment_key_info') }}</span>
                            </form-group>
                            <form-group class="row" label-class="col-4 col-form-label" reference-id="privateKeyPw"
                                        :label="__('sale.private_key_pw')">
                                <div class="input-group col-8">
                                    <input v-model="form.privateKeyPw" name="privateKeyPw" id="privateKeyPw"
                                           class="form-control" required
                                           :class="checkError(form.errors.privateKeyPw)"
                                           type="text"/>
                                </div>
                            </form-group>
                        </div>
                        <progress v-if="form.progress" :value="form.progress.percentage" max="100">
                            {{ form.progress.percentage }}%
                        </progress>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-light-primary font-weight-bold" @click="closeModal">
                            {{ __('general.close') }}
                        </button>
                        <button class="btn btn-success font-weight-bold"
                                @click.prevent="submitForm"
                                :disabled="form.processing">
                            {{ __('general.save') }}
                        </button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import {PaymentProviderMixin} from '@mixins/payment_providers'
import FormGroup from '@components/Form/FormGroup.vue'
import check_error from '@mixins/check_error'
import {Modal} from 'bootstrap'

export default {

    components: {FormGroup},

    mixins: [PaymentProviderMixin, check_error],

    props: {
        provider: Object,
        getAccountDetails: Boolean,
    },

    data() {
        return {
            form: this.$inertia.form({
                projectId: null,
                merchantId: null,
                projectPassword: null,

                clientId: null,
                clientSecret: null,

                privateKeyPw: null,
                privateKey: null,
            }),
            modal: null,
            accountData: {},
        }
    },

    mounted() {
        if (this.getAccountDetails && this.provider.id !== this.PaymentProvider.STRIPEID) {
            this.loadAccountData()
        }

        this.modal = new Modal(this.$refs.updateAccountDetails, {})
    },

    methods: {
        setPrivateKeyFile(event) {
            this.form.privateKey = event.target.files[0]
            this.$refs.fileLabel.innerText = this.form.privateKey.name
        },

        async loadAccountData() {
            let {data} = await axios.get(this.$route('get.account.details', {
                    storeUuid: this.$page.props.storeUuid,
                    payment_provider_id: this.provider.id,
                }),
            )
            this.accountData = data.data
            this.mapAccountDetails()
        },

        mapAccountDetails() {
            if (this.accountData) {
                switch (this.provider.id) {
                    case this.PaymentProvider.PAYPALID: {
                        this.form.clientId = this.accountData.clientId
                        this.form.clientSecret = this.accountData.clientSecret
                    }
                        break
                    case this.PaymentProvider.GIROPAYID: {
                        this.form.projectId = this.accountData.projectId
                        this.form.merchantId = this.accountData.merchantId
                        this.form.projectPassword = this.accountData.projectPassword
                    }
                        break
                    case this.PaymentProvider.GLOBALPAYMENTSID: {
                        this.form.merchantId = this.accountData.merchantId
                        this.form.privateKey = this.accountData.privateKey
                        this.form.privateKeyPw = this.accountData.privateKeyPw
                    }
                        break
                    default:
                        this.accountData = {}
                }
            }
        },

        submitForm() {
            this.form.post(
                this.$route('update.payment.account.details', {
                    storeUuid: this.$page.props.storeUuid,
                    payment_provider_id: this.provider.id,
                }).url(), {
                    onSuccess: () => {
                        this.closeModal()
                    },
                })
        },

        openModal() {
            this.modal.show()
        },

        closeModal() {
            this.modal.hide()
        },
    },
}
</script>
